import { createContext, useContext, useState, useEffect } from "react";

export const WHATSAPP_NUMBER = "523311645055";

export const dict = {
  en: {
    nav: { services: "Services", about: "About", testimonials: "Testimonials", contact: "Contact" },
    cta: "Request a quote",
    hero: {
      overline: "IP NET — Practical Solutions",
      lines: ["CONNECT.", "SECURE.", "SCALE."],
      sub: "IT consulting, network infrastructure, business email and web hosting — engineered without drama, delivered with precision. Practical technology for companies that can't afford downtime.",
      explore: "Explore services",
      stats: [
        { value: "99.9%", label: "Uptime commitment" },
        { value: "24/7", label: "Human support" },
        { value: "15+", label: "Years of practice" },
      ],
    },
    marquee: ["IT Consulting", "Network Infrastructure", "Business Email", "Web Hosting", "24/7 Support"],
    services: {
      tag: "Services",
      heading: "Everything your business needs to stay online.",
      quote: "Request a quote",
      items: [
        {
          id: "consulting",
          title: "IT Consulting",
          desc: "Technology audits, digital roadmaps and hands-on guidance. We tell you what you actually need — then we build it with you.",
          tags: ["Audits", "Strategy", "Migration"],
        },
        {
          id: "networking",
          title: "Network Infrastructure",
          desc: "Design, cabling and configuration of LAN/WAN, Wi-Fi, firewalls and VPNs. Fast, secure, documented.",
          tags: ["LAN / WAN", "Firewalls", "VPN"],
        },
        {
          id: "email",
          title: "Business Email",
          desc: "Professional mailboxes on your own domain with spam filtering, backup and migration from any provider.",
          tags: ["Your domain", "Anti-spam", "Backup"],
        },
        {
          id: "hosting",
          title: "Web Hosting",
          desc: "Fast, monitored hosting for your website with SSL, daily backups and real humans on support.",
          tags: ["SSL", "Backups", "Monitoring"],
        },
      ],
    },
    about: {
      tag: "About",
      heading: "Practical people, serious engineering.",
      body: "IP NET is an independent computing and networking consultancy. For over fifteen years we've kept offices, shops and industrial sites connected — designing networks, running business email and hosting websites that simply work.",
      values: [
        { k: "Plain language", v: "No jargon. We explain every decision and its cost." },
        { k: "Documented work", v: "Every network, password and config, handed over." },
        { k: "Long-term support", v: "We answer the phone after the invoice is paid." },
      ],
      caption: "IP NET HQ — Working session",
      roles: ["Founder / Networks Lead", "Systems & Hosting", "Email & Cloud", "Support Engineer"],
    },
    testimonials: {
      tag: "Testimonials",
      heading: "Trusted by businesses that can't go offline.",
      items: [
        {
          quote: "IP NET rebuilt our office network over a weekend. Zero downtime on Monday, and everything documented. First IT provider that ever did that.",
          name: "Carolina Vega",
          role: "Operations Director, Distribuidora Andina",
        },
        {
          quote: "Our company email used to land in spam half the time. Since the migration, deliverability is perfect and support answers in minutes, not days.",
          name: "Jorge Salinas",
          role: "Partner, Salinas & Asociados",
        },
        {
          quote: "They host our site and email for three years now. When our old server died, backups had us back online the same afternoon.",
          name: "María Fernanda Ríos",
          role: "Owner, MF Estudio Contable",
        },
      ],
    },
    contact: {
      tag: "Contact",
      heading: "Tell us what needs to work.",
      body: "Describe your project or problem — a new network, mailboxes for your team, hosting for your site, or all of the above. We'll reply with a practical plan and a clear quote.",
      responseLabel: "Response time",
      responseValue: "under 24h",
      supportLabel: "Support",
      supportValue: "24 / 7",
      labels: { name: "Name *", email: "Email *", company: "Company", service: "Service", message: "Message *" },
      placeholders: {
        name: "Your name",
        email: "you@company.com",
        company: "Company name",
        service: "Select a service",
        message: "Tell us about your project…",
      },
      services: ["IT Consulting", "Network Infrastructure", "Business Email", "Web Hosting", "Something else"],
      submit: "Request a quote",
      sending: "Sending…",
      toastOk: "Request received. We'll reply within one business day.",
      toastErr: "Could not send your request. Please try WhatsApp instead.",
    },
    footer: { rights: "IP NET — Soluciones Prácticas" },
    waText: "Hello IP NET, I'd like a quote.",
  },
  es: {
    nav: { services: "Servicios", about: "Nosotros", testimonials: "Testimonios", contact: "Contacto" },
    cta: "Solicitar cotización",
    hero: {
      overline: "IP NET — Soluciones Prácticas",
      lines: ["CONECTA.", "PROTEGE.", "ESCALA."],
      sub: "Consultoría en computación, infraestructura de redes, correo empresarial y hospedaje web — ingeniería sin dramas, entregada con precisión. Tecnología práctica para empresas que no pueden permitirse caídas.",
      explore: "Explorar servicios",
      stats: [
        { value: "99.9%", label: "Disponibilidad garantizada" },
        { value: "24/7", label: "Soporte humano" },
        { value: "15+", label: "Años de experiencia" },
      ],
    },
    marquee: ["Consultoría TI", "Infraestructura de Redes", "Correo Empresarial", "Hospedaje Web", "Soporte 24/7"],
    services: {
      tag: "Servicios",
      heading: "Todo lo que tu negocio necesita para seguir en línea.",
      quote: "Solicitar cotización",
      items: [
        {
          id: "consulting",
          title: "Consultoría TI",
          desc: "Auditorías tecnológicas, hojas de ruta digitales y acompañamiento práctico. Te decimos lo que realmente necesitas — y lo construimos contigo.",
          tags: ["Auditorías", "Estrategia", "Migración"],
        },
        {
          id: "networking",
          title: "Infraestructura de Redes",
          desc: "Diseño, cableado y configuración de LAN/WAN, Wi-Fi, firewalls y VPNs. Rápido, seguro, documentado.",
          tags: ["LAN / WAN", "Firewalls", "VPN"],
        },
        {
          id: "email",
          title: "Correo Empresarial",
          desc: "Buzones profesionales con tu propio dominio, filtro anti-spam, respaldo y migración desde cualquier proveedor.",
          tags: ["Tu dominio", "Anti-spam", "Respaldo"],
        },
        {
          id: "hosting",
          title: "Hospedaje Web",
          desc: "Hospedaje rápido y monitoreado para tu sitio web, con SSL, respaldos diarios y soporte de personas reales.",
          tags: ["SSL", "Respaldos", "Monitoreo"],
        },
      ],
    },
    about: {
      tag: "Nosotros",
      heading: "Gente práctica, ingeniería seria.",
      body: "IP NET es una consultora independiente de computación y redes. Por más de quince años hemos mantenido conectadas oficinas, comercios y plantas industriales — diseñando redes, operando correo empresarial y hospedando sitios web que simplemente funcionan.",
      values: [
        { k: "Lenguaje claro", v: "Sin jerga. Te explicamos cada decisión y su costo." },
        { k: "Trabajo documentado", v: "Cada red, contraseña y configuración, entregada a ti." },
        { k: "Soporte a largo plazo", v: "Contestamos el teléfono después de pagada la factura." },
      ],
      caption: "IP NET — Sesión de trabajo",
      roles: ["Fundador / Líder de Redes", "Sistemas y Hospedaje", "Correo y Nube", "Ingeniero de Soporte"],
    },
    testimonials: {
      tag: "Testimonios",
      heading: "La confianza de empresas que no pueden detenerse.",
      items: [
        {
          quote: "IP NET reconstruyó la red de nuestra oficina en un fin de semana. Cero caídas el lunes, y todo documentado. El primer proveedor de TI que hace eso.",
          name: "Carolina Vega",
          role: "Directora de Operaciones, Distribuidora Andina",
        },
        {
          quote: "Nuestro correo empresarial caía en spam la mitad del tiempo. Desde la migración, la entrega es perfecta y el soporte responde en minutos, no en días.",
          name: "Jorge Salinas",
          role: "Socio, Salinas & Asociados",
        },
        {
          quote: "Hospedan nuestro sitio y correo desde hace tres años. Cuando murió nuestro servidor viejo, los respaldos nos tenían en línea esa misma tarde.",
          name: "María Fernanda Ríos",
          role: "Propietaria, MF Estudio Contable",
        },
      ],
    },
    contact: {
      tag: "Contacto",
      heading: "Cuéntanos qué necesitas que funcione.",
      body: "Describe tu proyecto o problema — una red nueva, buzones para tu equipo, hospedaje para tu sitio, o todo lo anterior. Te responderemos con un plan práctico y una cotización clara.",
      responseLabel: "Tiempo de respuesta",
      responseValue: "menos de 24 h",
      supportLabel: "Soporte",
      supportValue: "24 / 7",
      labels: { name: "Nombre *", email: "Correo *", company: "Empresa", service: "Servicio", message: "Mensaje *" },
      placeholders: {
        name: "Tu nombre",
        email: "tu@empresa.com",
        company: "Nombre de la empresa",
        service: "Selecciona un servicio",
        message: "Cuéntanos sobre tu proyecto…",
      },
      services: ["Consultoría TI", "Infraestructura de Redes", "Correo Empresarial", "Hospedaje Web", "Otro"],
      submit: "Solicitar cotización",
      sending: "Enviando…",
      toastOk: "Solicitud recibida. Te responderemos en un día hábil.",
      toastErr: "No se pudo enviar tu solicitud. Intenta por WhatsApp.",
    },
    footer: { rights: "IP NET — Soluciones Prácticas" },
    waText: "Hola IP NET, quisiera una cotización.",
  },
};

const LangContext = createContext({ lang: "en", t: dict.en, setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ipnet-lang") || "es");
  useEffect(() => {
    localStorage.setItem("ipnet-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangContext.Provider value={{ lang, t: dict[lang], setLang }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
